export class ListAvailableRepositoriesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "repositories",
            "baseName": "repositories",
            "type": "Array<AvailableRepository>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAvailableRepositoriesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
